export default () => {
    // Expose variables, mostly for legacy support
    window.FC = window.FC || {};
    window.FC.plugins = window.FC.plugins || {};
    window.FC.vent = window.FC.vent || {};
    window.FC.vent.on = function () {};
    window.FC.ads = window.FC.ads || {};
};
